var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-footer flexr justify_center"},[_c('p',[_vm._v("Copyright © 安陆市涢创投资开发有限公司 Rights Reserved"),_c('br'),_vm._v(" 鄂ICP备2025107417号-1")])])
}]

export { render, staticRenderFns }